"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CancelDisassembler = /** @class */ (function () {
    function CancelDisassembler(sender, id, payloadType) {
        this.sender = sender;
        this.id = id;
        this.payloadType = payloadType;
    }
    CancelDisassembler.prototype.disassemble = function () {
        var header = { payloadType: this.payloadType, payloadLength: 0, id: this.id, end: true };
        this.sender.sendPayload(header);
    };
    return CancelDisassembler;
}());
exports.CancelDisassembler = CancelDisassembler;
//# sourceMappingURL=cancelDisassembler.js.map